$(document).ready(function(){
	var $someImages = $('.ofi');
	objectFitImages($someImages);
});